<template>
    <div class="o-crop">
        <template v-if="user">
            <m-title :title="user.full_name" />
            <div class="l-row">
                <div class="l-row__column">
                    <template v-if="user.roles && user.roles.length > 0">
                        <p class="a-label">Rola</p>
                        <p class="a-text">{{ user.roles.map(role => role.name).join(', ') }}</p>
                    </template>
                    <template v-if="user.province">
                        <p class="a-label">Województwo</p>
                        <p class="a-text">{{ user.province }}</p>
                    </template>
                    <template v-if="user.counties && user.counties.length > 0">
                        <p class="a-label">Powiat</p>
                        <p class="a-text">{{ user.counties.map(role => role.name).join('; ') }}</p>
                    </template>
                    <template v-if="user.last_login">
                        <p class="a-label">Ostatnie logowanie</p>
                        <p class="a-text">{{ formatDate(user.last_login) }}</p>
                    </template>
                    <template v-else>
                        <p class="a-label">Ostatnie logowanie</p>
                        <p class="a-text">Użytkownik jeszcze się nie logował.</p>
                    </template>
                </div>
            </div>
        </template>
        <a-spinner v-else />
    </div>
</template>

<script>
export default {
    metaInfo() {
        return {
            title: this.metaTitle
        }
    },
    data() {
        return {
            metaTitle: 'Użytkownik'
        }
    },
    computed: {
        user() {
            return this.$store.getters.user
        },
        note: {
            get() {
                return this.$store.getters.userNote
            },
            set(note) {
                this.noteValue = note
            }
        },
        usersRelated() {
            return this.$store.getters.usersRelated
        }
    },
    methods: {
        fetchUser() {
            if(!isNaN(this.$route.params.id)) {
                this.$store.dispatch('fetchUser', this.$route.params.id).then(() => {
                    this.metaTitle = this.user.full_name
                })
            } else {
                this.$router.push({ name: 'error404' })
            }
        },
        submitNote() {
            this.$store.dispatch('submitNote', {
                id: this.user.id,
                note: this.noteValue
            }).then(() => {
                this.$store.dispatch('modalHide')
                this.$store.dispatch('addNotification', {
                    type: 'success',
                    content: 'Dodano notatkę'
                })
                this.fetchUser()
            }).catch(() => {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Wystąpił błąd podczas dodawania notatki.'
                })
            })
        },
        openLabel(url) {
            window.open(url, '_blank')
        },
        formatDate(date) {
            return this.$dayjs(date).format('DD.MM.YYYY, HH:mm:ss')
        }
    },
    created() {
        this.fetchUser()
    }
}
</script>